<template>
  <div>
    <b-row no-gutters align-v="center" class="ml-2 ml-sm-0 d-sm-flex" :class="{ 'justify-content-sm-center': variant !== 'basket' }">
      <b-col cols="auto">
        <section v-if="pet.images && pet.images.length > 0 && pet.images[0].original">
          <b-avatar class="d-lg-none" :src="getImage(pet.images[0].original)" :size="variant === 'basket' ? '2.5em' : '4em'" alt="" />
          <b-avatar
            class="d-none d-lg-block"
            :src="getImage(pet.images[0].original)"
            :size="variant === 'basket' ? '3.5em' : '5em'"
            alt=""
          />
        </section>
        <section v-else>
          <b-avatar
            class="d-lg-none"
            :src="require('@/assets/images/paw_print.png')"
            :size="variant === 'basket' ? '2.5em' : '3.5em'"
            alt=""
          />
          <b-avatar
            class="d-none d-lg-block"
            :src="require('@/assets/images/paw_print.png')"
            :size="variant === 'basket' ? '3.5em' : '4.5em'"
            alt=""
          />
        </section>
      </b-col>
      <b-col cols="auto">
        <h2 class="ml-3 mb-0" :class="{ 'pet-header-text': variant !== 'basket' }" v-testid="variant === 'basket' ? 'sidebar-pet-name-message' : null">
          <!-- eslint-disable-next-line vue/no-v-html (Make sure it's always hard-coded) -->
          <strong v-if="!isAdmin" v-html="$t(`petHeader.title.${variant}`, { petName: pet.name })" />
          <!-- eslint-disable-next-line vue/no-v-html (Make sure it's always hard-coded) -->
          <strong v-else v-html="$t('petHeader.title.admin', { petName: pet.name })" />
          <span v-if="tagsAsText">
            <b-button id="tooltip-recent-tag-info" class="tooltip-btn" :title="`${tagsAsText} info`">
              <fa-icon :icon="['far', 'tags']" style="font-size: 0.5em" class="text-secondary mb-1 ml-1 tooltip-info" />
            </b-button>
            <b-tooltip target="tooltip-recent-tag-info" triggers="hover click blur" placement="rightbottom" custom-class="ml-1">
              {{ tagsAsText }}
            </b-tooltip>
          </span>
        </h2>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import getImage from '@/mixins/getImage';

export default {
  name: 'PetHeader',
  mixins: [getImage],
  props: {
    variant: {
      type: String,
      required: false,
      default: 'default',
    },
    pet: {
      type: Object,
      required: true,
    },
    isAdmin: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    tagsAsText() {
      if (!this.isAdmin) {
        return '';
      }
      let text = '';
      if (this.pet?.petTags?.length > 0) {
        this.pet?.petTags?.forEach((tag) => {
          if (tag.isValidInCurrentCity && tag.product) {
            text = `${tag.product.name} - ${tag.product.size === '3/L' ? 'Large' : 'Small'}`;
          }
        });
      }
      return text;
    },
  },
};
</script>

<style lang="scss" scoped>
.pet-header-text {
  @media (min-width: 992px) {
    font-size: 2rem !important;
  }
}
</style>
